// Explain the current cached inventory without scanning folders or guessing IDs.
export function studyMatchStatus(studies, studyId) {
  const matches = studies.filter((study) => String(study.studyId || '') === String(studyId));
  const location = (study) =>
    `${study.folder ? `${study.folder}/` : ''}${study.rep?.name || `${study.stem}.REP`}`;
  if (matches.length) {
    return matches
      .map((study) => {
        const source = location(study);
        if (!study.rep)
          return `Study ID ${studyId}: REP unavailable in the current index (${source}).`;
        if (!study.main) {
          const expected = `${study.folder ? `${study.folder}/` : ''}${study.stem}.qrs`;
          return `Study ID ${studyId}: REP found (${source}), but no primary QRS is indexed. Expected: ${expected}. A/B QRS files are optional and cannot replace the primary QRS.`;
        }
        return `Study ID ${studyId}: REP and primary QRS found, but study is unavailable: ${study.status || 'readiness validation failed'} (${source}).`;
      })
      .join(' ');
  }
  const unknown = studies.filter((study) => study.rep && !study.studyId);
  const orphanCount = studies.filter((study) => !study.rep && study.main).length;
  let message = `No indexed REP has Study ID ${studyId}.`;
  if (unknown.length) {
    message += ` ${unknown.length} REP file(s) have unreadable or unavailable Study IDs; their association with this PDF is unknown.`;
    message += unknown
      .slice(0, 3)
      .map((study) => ` ${location(study)}: ${study.metadataWarning || 'Study ID unavailable'}.`)
      .join('');
    if (unknown.length > 3) message += ' Additional files are listed in the study selector.';
  }
  if (orphanCount)
    message += ` ${orphanCount} primary QRS group(s) have no indexed REP; their association with this PDF is unknown.`;
  return `${message} Check the selected study folders, filename pairing, and helper connection. This describes the current index, not a new disk scan.`;
}
